import { render, staticRenderFns } from "./SliceDonationWidget.vue?vue&type=template&id=77ea6232&scoped=true"
import script from "./SliceDonationWidget.vue?vue&type=script&lang=js"
export * from "./SliceDonationWidget.vue?vue&type=script&lang=js"
import style0 from "./SliceDonationWidget.vue?vue&type=style&index=0&id=77ea6232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea6232",
  null
  
)

export default component.exports